// @flow

export type Ease = (t: number, from: number, to: number) => number;

export const easeInSine: Ease = (t, from, to) => {
  const d = 1;
  const c = to - from;
  return -c * Math.cos((t / d) * (Math.PI / 2)) + c + from;
};

export const easeInCubic: Ease = (t, from, to) => {
  const d = 1;
  const c = to - from;

  return c * (t /= d) * t * t + from;
};

export const easeOutCubic: Ease = (t, from, to) => {
  const d = 1;
  const c = to - from;

  t /= d;
  t -= 1;
  return c * (t * t * t + 1) + from;
};

export const easeInQuad: Ease = (t, from, to) => {
  const d = 1;
  const c = to - from;

  t /= d;
  return c * t * t + from;
};

export const easeOutQuad: Ease = (t, from, to) => {
  const d = 1;
  const c = to - from;

  t /= d;
  return -c * t * (t - 2) + from;
};
